import React from "react";

function initials(name) {
  return (name || "?").split(/\s+/).slice(0, 2).map((s) => s[0]?.toUpperCase()).join("");
}

// Recursive tree renderer. Uses React.createElement for the self-reference so
// babel/react-refresh doesn't recurse infinitely at compile time.
export function OrgNode({ node }) {
  const kids = node.children || [];
  return (
    <div className="flex flex-col items-center">
      <div
        className="border border-zinc-300 bg-white rounded-sm px-2 py-1.5 shadow-sm min-w-[140px] max-w-[170px]"
        data-testid={`org-node-${node.id}`}
      >
        <div className="flex items-center gap-1.5">
          {node.profile_photo_url ? (
            <img src={node.profile_photo_url} alt="" className="w-6 h-6 rounded-full object-cover shrink-0" />
          ) : (
            <div className="w-6 h-6 rounded-full bg-zinc-100 flex items-center justify-center text-[9px] font-semibold text-zinc-500 shrink-0">
              {initials(node.name)}
            </div>
          )}
          <div className="min-w-0">
            <div className="text-[11px] font-semibold truncate leading-tight" title={node.name}>{node.name}</div>
            <div className="text-[9px] text-zinc-500 truncate leading-tight" title={node.title}>{node.title || "—"}</div>
          </div>
        </div>
      </div>
      {kids.length > 0 && (
        <>
          <div className="w-px h-3 bg-zinc-300" />
          <div className="flex gap-2 relative pt-1.5 border-t border-zinc-300 px-1.5">
            {kids.map((c) =>
              React.createElement("div", { key: c.id, className: "relative" },
                React.createElement(OrgNode, { node: c })
              )
            )}
          </div>
        </>
      )}
    </div>
  );
}
